<template>
    <div class="container">
        <div class="address">
            <template>{{results.length > 0 ? results[0].formatted_address : "&nbsp;"}}</template>
            <template v-if="isSettingAddress || inDebounce">
                &nbsp;
                <svg width="16" height="16">
                    <use xlink:href="#loading"/>
                </svg>
            </template>
        </div>
        <gmap-map ref="addressMap"
                  v-bind="options"
                  @drag="centerChange"
                  id="map">
            <GmapMarker :position="marker"/>
        </gmap-map>
    </div>
</template>

<script>
    import {gmapApi} from 'vue2-google-maps';
    import {mapGetters} from 'vuex'
    import {debounce} from "../../utils/main_utils";
    import Vue from 'vue'

    var do_lookup = debounce(function (that, position) {
        that.inDebounce = false
        Vue.$gmapApiPromiseLazy().then(() => {
            const geocoder = new google.maps.Geocoder()
            geocoder.geocode({location: {lat: position.lat, lng: position.lng}, language: 'en'}, (results, status) => {
                if (status === 'OK') {
                    that.results = results
                }
            })
        })
    }, 300)

    export default {
        name: "GoogleMap",
        data() {
            return {
                options: {
                    zoom: 10,
                    center: {
                        lat: 0,
                        lng: 0
                    },
                },
                marker: {
                    lat: 0,
                    lng: 0
                },
                results: "",
                inDebounce: false
            };
        },
        computed: {
            shouldButtonBeDisabled()
            {
                return this.isSettingAddress || this.inDebounce
            },
            google: gmapApi,
            ...mapGetters([
                '_T',
                'currentCountryFullName',
                'customerPosition',
                'customerFullAddress',
                'isSettingAddress'
            ])
        },
        methods: {
            centerChange() {
                this.mark(this.$refs.addressMap.$mapObject.center)
            },
            fitBounds(geometry) {
                this.options.center.lat = geometry.location.lat()
                this.options.center.lng = geometry.location.lng()
                this.$refs.addressMap.fitBounds(geometry.viewport)
            },
            mark(event) {
                let lat, lng = undefined
                if (event.hasOwnProperty('latLng')) {
                    lat = event.latLng.lat()
                    lng = event.latLng.lng()
                } else {
                    lat = event.lat()
                    lng = event.lng()
                }
                this.decodeLatLong({lat, lng, force_country: true})
            },
            decodeLatLong(position) {
                this.inDebounce = true;
                var that = this
                do_lookup(that, position)
                this.marker = position
            },
            setMapByName(location) {
                this.$gmapApiPromiseLazy().then(() => {
                    const geocoder = new google.maps.Geocoder()
                    geocoder.geocode({address: location}, (results, status) => {
                        if (status === 'OK') {
                            this.fitBounds(results[0].geometry)
                            this.mark(results[0].geometry.location)
                        }
                    })
                })
            },
            applyAddress() {
                this.$store.dispatch('setCustomerCoordinatesAndAddress', {
                    results: this.results,
                    coordinates: this.marker
                })
            }
        },
        mounted() {
            if (this.customerPosition === undefined || this.customerPosition === "" || this.customerFullAddress == "") {
                this.setMapByName(this.currentCountryFullName)
            } else {
                this.marker = this.customerPosition.coordinates
                this.options.center.lat = this.customerPosition.coordinates.lat
                this.options.center.lng = this.customerPosition.coordinates.lng
                this.decodeLatLong(this.customerPosition.coordinates)
                this.options.zoom = 17
            }
        }
    };
</script>

<style lang="scss" scoped>
    #map {
        height: 60vh;
        width: 100%;
        margin: 0 auto;
        margin-bottom:$px5;
    }

    .address {
        margin-bottom: $px5;
        min-height: 1.5rem;
    }
</style>
